import {
  Checkbox as AriaCheckbox,
  type CheckboxProps as AriaCheckboxProps,
  composeRenderProps,
} from "react-aria-components";
import { tv } from "tailwind-variants";
import { focusRing } from "./primitive";

const checkboxStyles = tv({
  extend: focusRing,
  base: "group flex cursor-pointer items-start gap-2 text-sm text-fg transition-colors disabled:cursor-default disabled:opacity-50",
});

const boxStyles = tv({
  base: [
    "mt-0.5 flex size-4 shrink-0 items-center justify-center rounded border border-fg/40 transition-colors",
    "group-selected:border-primary group-selected:bg-primary",
  ],
});

export interface CheckboxProps extends AriaCheckboxProps {}

export function Checkbox({ className, children, ...props }: CheckboxProps) {
  return (
    <AriaCheckbox
      className={composeRenderProps(className, (className, renderProps) =>
        checkboxStyles({
          ...renderProps,
          className,
        }),
      )}
      {...props}
    >
      {composeRenderProps(children, (children) => (
        <>
          <div className={boxStyles()}>
            <svg
              viewBox="0 0 14 14"
              fill="none"
              aria-hidden="true"
              className="size-3 text-primary-fg opacity-0 transition-opacity group-selected:opacity-100"
            >
              <path
                d="m3 7 3 3 5-6"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          {children}
        </>
      ))}
    </AriaCheckbox>
  );
}
